import { formatNumber } from "utils";
import moment from "moment";
import { DateTime } from "enums";
import locale from "localization";
import { prettifyAwardCategory, prettifyVipTransactionHistoryStatus } from "utils/pretty.utils";
import { Pill, PopOver, PopOverMenu } from "components/commons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { VIPAwardPointsStatusEnum } from "enums/vip-transaction-history-status";
import styles from "./redeem-history.module.scss";

export const mapDataToList = ({ conversionHistory, onOptionClickVoid, getUserAccess }) => {
  const {
    cardNumber,
    points,
    mobileNumber,
    rewardRedeemed,
    createdAt,
    transactionId,
    remarks,
    station,
    status,
    name,
  } = conversionHistoryType(conversionHistory);

  const options = [];
  if (getUserAccess?.fullAccess || getUserAccess?.voidAccess) {
    if (status !== VIPAwardPointsStatusEnum.Voided) {
      options.push({
        content: locale.void,
        onClick: () => {
          onOptionClickVoid?.(conversionHistory);
        },
      });
    }
  }

  const styleCell = {
    wordBreak: "break-all",
  };

  const print = (val) => {
    return val ? val : "--";
  };

  return {
    vipTransactionId: (
      <div
        style={{
          ...styleCell,
          width: "100px",
        }}
      >
        {print(transactionId)}
      </div>
    ),
    nameAndMobileNumber: (
      <div
        style={{
          ...styleCell,
          width: "130px",
        }}
      >
        {print(name)}
        <br />
        {print(mobileNumber)}
      </div>
    ),
    vipCardNumber: (
      <div
        style={{
          ...styleCell,
          width: "100px",
        }}
      >
        {print(cardNumber)}
      </div>
    ),

    station: (
      <div
        style={{
          ...styleCell,
          width: "150px",
        }}
      >
        {print(station)}
      </div>
    ),

    pointsEarned: (
      <div
        style={{
          ...styleCell,
          width: "80px",
        }}
      >
        {formatNumber(print(points), 2)} pts
      </div>
    ),
    rewardsRedeemed: (
      <div
        style={{
          ...styleCell,
          width: "80px",
        }}
      >
        {prettifyAwardCategory(print(rewardRedeemed))}
      </div>
    ),
    dateOfTransaction: (
      <div
        style={{
          ...styleCell,
          width: "80px",
        }}
      >
        {moment(createdAt).format(DateTime.K)}
      </div>
    ),
    status: (
      <Pill
        grass={status === VIPAwardPointsStatusEnum.Success}
        cement={status === VIPAwardPointsStatusEnum.Voided}
        style={{
          ...styleCell,
          width: "80px",
        }}
      >
        {prettifyVipTransactionHistoryStatus(print(status))}
      </Pill>
    ),
    remarks: remarks && (
      <PopOver content={<div className={styles.remarks}>{remarks}</div>}>
        <div
          className="link"
          style={{
            ...styleCell,
            width: "80px",
          }}
        >
          <b>{locale.view}</b>
        </div>
      </PopOver>
    ),
    action: options.length > 0 && (
      <PopOverMenu options={options}>
        <MoreVertIcon className={styles.icon} />
      </PopOverMenu>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { referenceStation, ...fs } = filterState;

  if (referenceStation.value.length > 0) {
    fs.stationIds = referenceStation.value.map(({ value }) => value).join(",");
  }

  if (referenceStation.isSelectedAll) {
    fs.stationIds = undefined;
  }

  return {
    ...fs,
  };
};

export const conversionHistoryType = (responseData) => {
  return {
    pointsHistoryId: responseData?.pointsHistoryId,
    userId: responseData?.userId,
    fleetId: responseData?.fleetId,
    name: responseData?.name,
    cardNumber: responseData?.cardNumber,
    points: responseData?.points,
    awardType: responseData?.awardType,
    transactionId: responseData?.pointsHistoryId,
    productCode: responseData?.productCode,
    stationId: responseData?.stationId,
    mobileNumber: responseData?.mobileNumber,
    amount: responseData?.amount,
    finalAmount: responseData?.finalAmount,
    rewardRedeemed: responseData?.rewardRedeemed,
    createdAt: responseData?.createdAt,

    //
    station: responseData?.station?.name,
    orNumber: responseData?.transactionId,
    status: responseData?.status,
    remarks: responseData?.remarks,
  };
};
